// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventLanding/LandingDetails/LandingDetails.css
// module id = 1785
// module chunks = 0